"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternalLink = void 0;

var isExternalLink = function isExternalLink(targetUrl) {
  if (!targetUrl) return null;
  var url = /^((http|https):\/\/)/;
  return url.test(targetUrl);
};

exports.isExternalLink = isExternalLink;